/* eslint react/forbid-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { Offline, Online } from 'react-detect-offline';

import * as selectors from '../redux/selectors';
import {
  authenticateCurrentUser,
  authenticateLogout,
} from '../redux/authenticate/actions';
import { resetStore } from '../redux/storage/actions';

import { getTrackID } from '../redux/track/actions';
import { detectBrowser } from '../utils/detectBrowser';
import { detectDevice } from '../utils/detectDevice';

import Routes from '../Routes';
import config from '../config';

import MessageForm from '../components/MessageForm';
import ScrollToTop from '../components/ScrollToTop';
import Modal from '../components/Modal';
import { sendHeight } from '../utils/postMessage';

import logo from '../assets/logos/logo.svg';
import secureIcon from '../assets/icons/secure-icon-grey.svg';
import ctos from '../assets/images/Ctos_logo_grey.svg';

import './App.css';

class App extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    userToken: PropTypes.string,
    fromFrame: PropTypes.bool,
    trackID: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    check: PropTypes.shape({
      dsrPercent: PropTypes.number,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultProps = {
    userToken: null,
    fromFrame: false,
    trackID: null,
    check: {
      dsrPercent: null,
    },
  }
  static mapStateToProps = state => ({
    trackID: selectors.getIDTrack(state),
    userToken: selectors.getAuthenticateUserToken(state),
    fromFrame: selectors.getAuthenticateFromFrame(state),
    location: state.router.location,
    check: selectors.getCheck(state),
  })
  constructor(props) {
    super(props);
    this.appElement = null;
    this.appHeight = 0;
    this.state = {
      showModal: false,
      link: null,
      // reveal: null,
    };
  }
  async componentDidMount() {
    await this.start();
    await this.checkLogOut();
    if (config.bugSnag.RELEASE !== 'development') {
      window.addEventListener('beforeunload', this.onUnload, false);
    }
    this.heightChangeInterval = setInterval(() => {
      const changed = this.checkHeightChange();
      if (changed) {
        sendHeight(this.appHeight);
      }
    }, 500);
  }
  componentWillUnmount() {
    clearTimeout(this.heightChangeInterval);
  }

  onUnload = async () => {
    const { store } = this.context;
    await this.handleExit();
    await store.dispatch(resetStore());
  }
  getQuery = () => {
    const { search } = window.location;
    let query = queryString.parse(search);
    // remove redirect query in query string
    if (query.redirect) {
      let str = query.redirect;
      str = str.substring(str.indexOf('?') + 0);
      query = queryString.parse(str);
    }
    return query;
  }
  checkHeightChange = () => {
    if (this.appElement && (this.appHeight !== this.appElement.clientHeight)) {
      this.appHeight = this.appElement.clientHeight;
      return true;
    }
    return false;
  }
  checkLogOut = async () => {
    if (this.isIframe && !this.props.trackID) {
      if (config.bugSnag.RELEASE !== 'development') {
        await this.handleExit();
      }
    }
  }
  async start() {
    const { store } = this.context;
    const { trackID } = await this.getQuery();
    await store.dispatch(authenticateCurrentUser());
    await store.dispatch(getTrackID(trackID));
  }
  handleExit = async () => {
    const { store } = this.context;
    await store.dispatch(authenticateLogout());
  }
  handleOpenModal = (event) => {
    event.preventDefault();
    this.setState({
      showModal: true,
      link: event.currentTarget.href,
    });
  }
  handleCloseModal = () => {
    this.setState({
      showModal: false,
      showSupportModal: false,
      showEmail: false,
    });
  }
  handleLeavePage = () => {
    window.open(this.state.link);
    this.setState({
      showModal: false,
    });
  }

  isIframe = () => (window.location !== window.parent.location)

  // revealButton = () => {
  //   const y = window.scrollY;
  //   if (y <= 45) {
  //     this.setState({
  //       reveal: 'hide',
  //     });
  //   } else {
  //     this.setState({
  //       reveal: 'show',
  //     });
  //   }
  // }

  contactUs = () => {
    if (this.props.userToken) {
      this.setState({
        showSupportModal: true,
      });
      return;
    }
    this.setState({
      showEmail: true,
    });
  }

  inResultPage = () => {
    const { check } = this.props;
    if (this.props.history.location.pathname === '/status/result' && check && (check.dsrPercent || check.dsrPercent === 0)) {
      return true;
    }
    return false;
  }

  // hideSupport = () => {
  //   if (
  //     this.props.history.location.pathname === '/' ||
  //     this.props.history.location.pathname === '/agreements' ||
  //     this.props.history.location.pathname === '/agreements/terms' ||
  //     this.props.history.location.pathname === '/faq'
  //   ) {
  //     return false;
  //   }
  //   return true;
  // }

  render() {
    const childProps = {
      className: 'App-contents',
      userToken: this.props.userToken,
      fromFrame: this.props.fromFrame,
      trackID: this.props.trackID,
    };
    const { history } = this.props;

    return (
      <div className={`App ${history.location.pathname === '/' ? 'full' : ''}`} ref={(ref) => { this.appElement = ref; }}>
        <Modal
          close={this.state.showModal}
          onClickNo={this.handleCloseModal}
          onClickYes={this.handleLeavePage}
        >
          Are you sure you want to open new tab?
        </Modal>

        {
          this.state.showEmail ?
            <div className="Modal">
              <div className="simple-modal">
                <h1>Need help?</h1>
                <p>Please email to dsr@mhub.my.</p>
                <div className="modal-buttons">
                  <button className="Button" onClick={this.handleCloseModal}>Okay</button>
                </div>
              </div>
            </div>
          : null
        }

        <MessageForm
          version={config.app.version}
          page={this.props.location.pathname}
          device={detectDevice()}
          browser={detectBrowser()}
          close={this.state.showSupportModal}
          onClick={this.handleCloseModal}
        />

        <section className="header">
          <div className="wrapper">
            <div>
              <h1>Mortgage Pre-Qualifier</h1>
            </div>
            <div className="rightHeader">
              <p>A Solution By</p>
              <a href="https://mhub.my/" id="mhub" onClick={this.handleOpenModal}>
                <img src={logo} alt="MHub" />
              </a>
            </div>
          </div>
        </section>
        <ConnectedRouter history={this.props.history}>
          <span>
            <Offline>
              <div className="container">
                <div className="wrapper offline">
                  <h3>Sorry, there is no internet connection.</h3>
                  <p>Please check your connection or try again</p>
                </div>
              </div>
            </Offline>
            <Online>
              <ScrollToTop>
                <div className="container">
                  <div className={`wrapper ${this.inResultPage() ? 'resultBackground' : ''}`}>
                    <Routes childProps={childProps} />

                    <div>
                      <div className="footer">
                        <div className="ctos-footer noPrint">
                          <img src={secureIcon} alt="secured" />
                          <div>
                            <span><p>Powered by</p> <img src={ctos} alt="secured" /></span>
                            <p>Registrars of CRAs 100% secure</p>
                          </div>
                        </div>

                        <div className="ctos-footer showPrint">
                          <img src={secureIcon} alt="secured" />
                          <div>
                            <span><p>Powered by</p> <img src={ctos} alt="secured" /></span>
                            <p>Registrars of CRAs 100% secure</p>
                          </div>
                        </div>

                        <div className="support">
                          <div className="navigation">
                            <a href="https://mhub.my/who-we-are/" onClick={this.handleOpenModal}> MHub </a>
                            <Link to="/faq">FAQ</Link>
                            <Link to="/agreements/terms">Terms</Link>
                            <button onClick={this.contactUs}>Help</button>
                          </div>

                          <p className="version">v{config.app.version}</p>
                        </div>
                      </div>

                      {
                        process.env.REACT_APP_BUGSNAG_RELEASE !== 'production' &&
                        <div className="footer-wrapper noPrint">
                          <nav>
                            <ul>
                              {
                                <li><Link to="/">Home</Link></li>
                              }
                              {
                                !this.props.userToken && [
                                  <li key="1"><Link to="/login">Login</Link></li>,
                                  <li key="2"><Link to="/register">Signup</Link></li>,
                                ]
                              }
                              {
                                this.props.userToken && [
                                  <li key="1"><Link to="/run">Run Check</Link></li>,
                                  <li key="2"><Link to="/status">Status</Link></li>,
                                ]
                              }
                              {
                                this.props.userToken &&
                                <li key="3"><button onClick={this.handleExit}>Exit</button></li>
                              }
                            </ul>
                          </nav>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </ScrollToTop>
            </Online>
          </span>
        </ConnectedRouter>
      </div>
    );
  }
}

export default connect(App.mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.jsx